import { computed } from "vue";

import useVuelidate from "@vuelidate/core";
import { helpers, minLength, required } from "@vuelidate/validators";
import { useLearningPathStore } from "~/store/learning-path/learning-path.store";

// Singletons for each step
let generalValidator: any = null;
let trainingsValidator: any = null;
let addTrainingValidator: any = null;

export const useLearningPathValidation = () => {
  function validateStepGeneral() {
    // Return the existing instance or create a new one
    if (generalValidator) {
      return generalValidator;
    }

    const learningPathStore = useLearningPathStore();

    const rules = computed(() => {
      return {
        form: {
          general: {
            name: { required: helpers.withMessage("Ce champ est obligatoire", required) },
          },
        },
      };
    });

    // Pass the store directly to validate the form property
    generalValidator = useVuelidate(rules, learningPathStore);
    return generalValidator;
  }

  function validateStepTrainings() {
    // Return the existing instance or create a new one
    if (trainingsValidator) {
      return trainingsValidator;
    }

    const learningPathStore = useLearningPathStore();

    const rules = computed(() => {
      return {
        form: {
          trainings: {
            required: helpers.withMessage("Ce champ est obligatoire", required),
            minLength: helpers.withMessage("Vous devez saisir au moins 1 formation", minLength(1)),
          },
        },
      };
    });
    // Pass the store directly to validate the form property
    trainingsValidator = useVuelidate(rules, learningPathStore);
    return trainingsValidator;
  }

  function validateAddTraining(trainingRef: any) {
    // Return the existing instance or create a new one
    if (addTrainingValidator) {
      return addTrainingValidator;
    }

    const rules = computed(() => {
      return {
        training: {
          required: helpers.withMessage("Ce champ est obligatoire", required),
        },
      };
    });

    // Create the validator with the ref passed as a parameter
    addTrainingValidator = useVuelidate(rules, { training: trainingRef });
    return addTrainingValidator;
  }

  // Function to reset the validators (useful when the modal is closed)
  function resetValidators() {
    generalValidator = null;
    trainingsValidator = null;
    addTrainingValidator = null;
  }

  return {
    validateStepGeneral,
    validateStepTrainings,
    validateAddTraining,
    resetValidators,
  };
};
